<script lang="ts">
  export let width: number;
  export let height: number;
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  {width}
  {height}
  enable-background="new 0 0 100 100"
  viewBox="0 0 100 100"
  id="playbutton"
>
  <switch>
    <g fill="#ffffff" class="color000000 svgShape">
      <!-- Circle (filled with white) -->
      <circle cx="50" cy="50" r="47.5" fill="white" />
      <!-- Triangle (filled with black) -->
      <path
        d="M67.2 52.8L41.6 69.8c-2.2 1.5-5.1-.1-5.1-2.8V32.9c0-2.6 2.9-4.2 5.1-2.8l25.6 17.1C69.2 48.6 69.2 51.4 67.2 52.8z"
        fill="black"
      />
    </g>
  </switch>
</svg>
